import { withEmptyOption } from '@app/modules/social-export/components/helpers/SelectOptions';
import { socialExport } from '@mi-front/api-clients';
import { SelectElement } from 'react-hook-form-mui';
import { defineMessages, useIntl } from 'react-intl';

const dailymotionChannelMessages = defineMessages({
  animals: {
    id: 'socialExport.dailymotion.channel.animals',
    defaultMessage: 'Animales',
  },
  auto: {
    id: 'socialExport.dailymotion.channel.auto',
    defaultMessage: 'Automóviles',
  },
  creation: {
    id: 'socialExport.dailymotion.channel.creation',
    defaultMessage: 'Creación',
  },
  fun: {
    id: 'socialExport.dailymotion.channel.fun',
    defaultMessage: 'Diversión',
  },
  kids: {
    id: 'socialExport.dailymotion.channel.kids',
    defaultMessage: 'Niños',
  },
  lifestyle: {
    id: 'socialExport.dailymotion.channel.lifestyle',
    defaultMessage: 'Estilo de vida',
  },
  music: {
    id: 'socialExport.dailymotion.channel.music',
    defaultMessage: 'Música',
  },
  news: {
    id: 'socialExport.dailymotion.channel.news',
    defaultMessage: 'Noticias',
  },
  people: {
    id: 'socialExport.dailymotion.channel.people',
    defaultMessage: 'Personas',
  },
  school: {
    id: 'socialExport.dailymotion.channel.school',
    defaultMessage: 'Escuela',
  },
  shortfilms: {
    id: 'socialExport.dailymotion.channel.shortfilms',
    defaultMessage: 'Cortometrajes',
  },
  sport: {
    id: 'socialExport.dailymotion.channel.sport',
    defaultMessage: 'Deportes',
  },
  tech: {
    id: 'socialExport.dailymotion.channel.tech',
    defaultMessage: 'Tecnología',
  },
  travel: {
    id: 'socialExport.dailymotion.channel.travel',
    defaultMessage: 'Viajes',
  },
  tv: { id: 'socialExport.dailymotion.channel.tv', defaultMessage: 'TV' },
  videogames: {
    id: 'socialExport.dailymotion.channel.videogames',
    defaultMessage: 'Videojuegos',
  },
  webcam: {
    id: 'socialExport.dailymotion.channel.webcam',
    defaultMessage: 'Webcam',
  },
});

export function DailymotionCategoryField() {
  const { formatMessage } = useIntl();
  const options = withEmptyOption(
    Object.values(socialExport.DailymotionSettingsDtoChannelEnum)
      .map((value: socialExport.DailymotionSettingsDtoChannelEnumKey) => ({
        id: value as string,
        label: formatMessage(
          dailymotionChannelMessages[value as keyof typeof dailymotionChannelMessages],
        ),
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  );
  return (
    <SelectElement
      name="channel"
      label={formatMessage({
        id: 'socialExport.form.category',
        defaultMessage: 'Categoría',
      })}
      options={options}
      fullWidth
    />
  );
}
